export default import.meta.ROLLDOWN_FILE_URL_d9QaJTiPH4fXgPH4OnM3hQ